import React from 'react';

import { SearchResults } from '@uncinc/react-searchkit';

import EventCard from '../../EventCard';
import { SearchEventHit } from '../types';

const SearchEventsResults: React.FC = () => (
  <SearchResults
    renderItem={(hit: SearchEventHit) => {
      const firstUpcomingStartDate =
        hit.event_date[hit.computed_first_upcoming_date_index[0]];
      const firstUpcomingEndDate =
        hit.event_date_end_value[hit.computed_first_upcoming_date_index[0]];

      /**
       * Apend +00:00 to the date registration.
       * We do this because the dates we receive from the API are stored in UTC.
       * By appending +00:00 we can handle them as such.
       */
      const startDate = new Date(firstUpcomingStartDate ? `${firstUpcomingStartDate}+00:00` : '');
      const endDate = new Date(firstUpcomingEndDate ? `${firstUpcomingEndDate}+00:00` : '');

      return (
        <EventCard
          title={hit.page_title[0]}
          link={hit.url[0]}
          startDate={startDate}
          image={hit.image_style_uri?.[0]}
          endDate={endDate}
          hasMultipleDates={hit.event_date_infinite.includes(true) || hit.event_date.length > 1}
        />
      );
    }}
  />
);

export default SearchEventsResults;
